import React from "react";
import { useTranslation } from "react-i18next";
import { KpiCard } from "../components/ui/KpiCard";
import SARIcon from "../components/SARIcon";

const parsePct = (p) => {
  if (typeof p === "number") return p;
  if (p == null || p === "") return null;
  const n = parseFloat(String(p).replace("%", "").trim());
  return Number.isNaN(n) ? null : n;
};

const trendFromPct = (n) => {
  if (n == null) return undefined;
  if (n < 0) return "down";
  if (n > 0) return "up";
  return "flat";
};

const KPICards = ({ kpis }) => {
  const { t, i18n } = useTranslation("translation");
  const isArabic = i18n.language === "ar";
  const locale = isArabic ? "ar" : undefined;

  const metric = (key, title, icon) => {
    const raw = kpis?.[key];
    const pct = parsePct(raw?.percentage);
    const numeric = typeof raw?.value === "number" ? raw.value : Number(raw?.value) || 0;
    const isCurrency = Boolean(raw?.currency);
    return {
      title,
      icon,
      value: numeric.toLocaleString(locale, {
        maximumFractionDigits: isCurrency ? 0 : 0,
        minimumFractionDigits: 0,
      }),
      prefix: isCurrency ? (
        <SARIcon size={14} color="#030f1b" className="oh-kpi-dash__sar" />
      ) : undefined,
      percentage: pct,
      trend: trendFromPct(pct),
    };
  };

  const kpiData = [
    metric("averageOrderValue", t("dashboardPage.kpis.averageOrderValue") || "Average Order Value", "aov"),
    metric("totalOrders", t("dashboardPage.kpis.totalOrders") || "Total Orders", "orders"),
    metric("netPayment", t("dashboardPage.kpis.netPayment") || "Net Payment", "payment"),
    metric("netSales", t("dashboardPage.kpis.netSales") || "Net Sale", "sales"),
  ];

  return (
    <div className="oh-kpi-grid" dir={isArabic ? "rtl" : undefined}>
      {kpiData.map((kpi) => (
        <KpiCard key={kpi.title} variant="dashboard" {...kpi} />
      ))}
    </div>
  );
};

export default KPICards;
